module.exports = __webpack_public_path__ + "18727d5dd0dffffe6da5203023a0cff7.svg";